import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "getHeaderTitle"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import { jsx as _jsx } from "react/jsx-runtime";
const SunsettedActionCard = _ref => {
  let {
      actionId,
      getHeaderTitle
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.sunsetted-action.action-detail.content"
    }),
    titleUseTheme: 'oz'
  }));
};
SunsettedActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default SunsettedActionCard;